import { AxiosResponse } from 'axios';
import { API } from '../../utils/axios';

export interface MfaRequest {
  email: string;
  mfaType?: 'email' | 'sms';
  mfaCode?: string;
}

export interface MfaResponse {
  statusCode: number;
  message: string;
  resource?: any;
}

class MfaService {
  static generateMfaCode(email: string): Promise<MfaResponse> {
    return API.post<MfaRequest, AxiosResponse<MfaResponse>>('v1/auth/mfa/generateCode', {
      email: email,
    }).then((res) => res.data);
  }

  static verifyMfaCode(email: string, mfaCode: string): Promise<MfaResponse> {
    return API.post<MfaRequest, AxiosResponse<MfaResponse>>('v1/auth/mfa/verifyCode', {
      email: email,
      mfaCode: mfaCode,
    }).then((res) => res.data);
  }

  static getMfaPreference(email: string): Promise<MfaResponse> {
    return API.get<MfaResponse>(`v1/auth/mfa/preference/${email}`).then((res) => res.data);
  }

  static updateMfaPreference(email: string, mfaType: 'email' | 'sms'): Promise<MfaResponse> {
    return API.post<MfaRequest, AxiosResponse<MfaResponse>>('v1/auth/mfa/update-preference', {
      email: email,
      mfaType: mfaType,
    }).then((res) => res.data);
  }
}

export default MfaService;
